import classNames from "classnames";
import React, { useContext } from "react";
import { StateContext } from "../context/stateContext";
import accordianStyles from "../styles/accordian.module.scss";

import { translations } from "../translate";
import DisconnectButton from "./DisconnectButton";
import { ExternalDocument } from "./ExternalDocument/ExternalDocument";
export type ScopeHtmlContent = {
  description: string;
  title: string;
  label: string;
};
type ThirdPartyPanelProps = {
  appName: string;
  onDisconnect: (_appName: string) => void;
  scopeDescriptions: ScopeHtmlContent[];
};
const ThirdPartyPanel: React.FC<ThirdPartyPanelProps> = ({ appName, onDisconnect, scopeDescriptions }) => {
  const language = useContext(StateContext).languageCode;
  return (
    <div className={accordianStyles.accordionContent}>
      {scopeDescriptions.map(element => (
        <ExternalDocument className={accordianStyles.externalDocument} key={element.title}>
          <h2 className={classNames(accordianStyles.h2, accordianStyles.consentTitle)}>{element.title}</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: element.description,
            }}
          ></div>
        </ExternalDocument>
      ))}
      {scopeDescriptions.length === 0 && (
        <>
          <h2 className={accordianStyles.h2}>{translations.personalInfo[language]}</h2>
          <ul className={accordianStyles.list}>
            <li>{translations.name[language]}</li>
            <li>{translations.address[language]}</li>
            <li>{translations.dateOfBirth[language]}</li>
            <li>{translations.otherPersonalInfo[language]}</li>
          </ul>
          <h2 className={accordianStyles.h2}>{translations.coverageInformation[language]}</h2>
          <ul className={accordianStyles.list}>
            <li>{translations.membershipDetails[language]}</li>
            <li>{translations.planInformation[language]}</li>
            <li>{translations.otherCoverageInformation[language]}</li>
          </ul>
          <h2 className={accordianStyles.h2}>{translations.prescriptionsAndMedications[language]}</h2>
          <ul className={accordianStyles.list}>
            <li>{translations.listOfPrescriptions[language]}</li>
            <li>{translations.medicationRequested[language]}</li>
            <li>{translations.medicationDiesensed[language]}</li>
          </ul>
          <h2 className={accordianStyles.h2}>{translations.clinicalInformation[language]}</h2>
          <ul className={accordianStyles.list}>
            <li>{translations.allergies[language]}</li>
            <li>{translations.carePlan[language]}</li>
            <li>{translations.careTeam[language]}</li>
            <li>{translations.conditions[language]}</li>
            <li>{translations.devices[language]}</li>
            <li>{translations.clinicalNotes[language]}</li>
            <li>{translations.healthGoals[language]}</li>
            <li>{translations.immunizationRecords[language]}</li>
            <li>{translations.locations[language]}</li>
            <li>{translations.observations[language]}</li>
            <li>{translations.practitionerRoles[language]}</li>
            <li>{translations.procedures[language]}</li>
          </ul>
          <h2 className={accordianStyles.h2}>{translations.claimsInformation[language]}</h2>
          <ul className={accordianStyles.list}>
            <li>{translations.explanationOfBenefits[language]}</li>
            <li>{translations.providersAndPractitioners[language]}</li>
            <li>{translations.facilitiesAndOrganizations[language]}</li>
          </ul>
        </>
      )}
      <div className={accordianStyles.buttonContainer}>
        <DisconnectButton
          buttonTitle={`${translations.disconnect[language]}`}
          dialogTitle={`${translations.disconnectQuestion[language](appName)}`}
          thirdPartyConsents={[appName]}
          disabled={false}
          onDisconnect={() => {
            onDisconnect(appName);
          }}
        />
      </div>
    </div>
  );
};

export default ThirdPartyPanel;
